import { Component, Input, OnInit } from '@angular/core';
import { BehaviorSubject, Subscription } from 'rxjs';
import { StatutAvisEnum } from '../../../../models/enums/statut-avis.enum';
import { AvisService } from '../../services/avis-service';

interface JsonResponse {
  avis: { [name: string]: string }[];
  flux: { [name: string]: string }[];
}

interface Histo {
  reference: string;
  date: Date;
  statut: string;
  type: Type;
}

enum Type { Avis, Flux }

@Component({
  selector: 'app-historique',
  templateUrl: './historique.component.html'
})
export class HistoriqueComponent implements OnInit {

  @Input() referenceAvis: string;
  @Input() currentJson: any = new BehaviorSubject(null);
  historique: Histo[]; //Map<StatutAvisEnum, Date>;
  histoAvis: string[];
  histoFlux: string[];
  type = Type;

  private subscriptions: Subscription = new Subscription();

  constructor(private _avisService: AvisService) {
  }

  public ngOnInit() {
    this.avisService.shouldUpdateSynthesis = false;
    this.getHistorique();
  }


  public getHistorique() {
    this.subscriptions.add(
      this.avisService.getHistorique(this.referenceAvis).subscribe((data: any[]) => {
        this.histoAvis = data;
        this.historique = this.listHistory();
      })
    );
  }

  private listHistory() {
    let historique: Histo[] = new Array();
    this.histoAvis.forEach((json) => {
      const histo: any = json;
      let h: Histo = { reference: histo.reference, date: new Date(), statut: histo.status, type: histo.type == "avis" ? Type.Avis : Type.Flux }
      if (histo.type == "avis") {
        if (!histo.historique.dateCreation) histo.historique.dateCreation = histo.dateCreation;
        if (!histo.historique.datePublication) histo.historique.datePublication = histo.dateReceptionBoamp ? histo.dateReceptionBoamp : (histo.dateReceptionJoue ? histo.dateReceptionJoue : histo.dateReception);
        if (!histo.historique.dateRejet) histo.historique.dateRejet = histo.dateReceptionBoamp ? histo.dateReceptionBoamp : (histo.dateReceptionJoue ? histo.dateReceptionJoue : histo.dateReception);
        h.date = histo.historique.dateCreation;
        /**
         * dateCreation: null
          dateEmission: null
          dateEnvoi: null
          dateReception: null
          dateReceptionBoamp: null
          dateReceptionJoue: null
          historique: {dateCreation: '2022-09-09T17:00:00.192', dateRejet: null, datePublication: null}
          id: 149
          idJoue: null
          reference: "2022-69273600"
          referenceBoamp: null
          referenceFlux: 340
          status: "ENVOYE"
          statusFlux: "AV"
          type: "avis"
         */
        switch (histo.status) {
          case StatutAvisEnum.ELABORE:
            historique.push(h);
            break;
          case StatutAvisEnum.EN_ATTENTE:
            historique.push({ reference: h.reference, date: h.date, statut: StatutAvisEnum.ELABORE, type: h.type });
            historique.push(h);
            break;
          case StatutAvisEnum.ENVOYE:
          case StatutAvisEnum.ANNULE:
            historique.push({ reference: h.reference, date: h.date, statut: StatutAvisEnum.ELABORE, type: h.type });
            historique.push({ reference: h.reference, date: h.date, statut: StatutAvisEnum.EN_ATTENTE, type: h.type });
            if (histo.dateEmission) h.date = histo.dateEmission;
            historique.push(h);
            break;
          case StatutAvisEnum.PUBLIE:
            historique.push({ reference: h.reference, date: h.date, statut: StatutAvisEnum.ELABORE, type: h.type });
            historique.push({ reference: h.reference, date: h.date, statut: StatutAvisEnum.EN_ATTENTE, type: h.type });
            if (histo.dateEmission) h.date = histo.dateEmission;
            historique.push({ reference: h.reference, date: h.date, statut: StatutAvisEnum.ENVOYE, type: h.type });
            h.date = histo.historique.datePublication;
            historique.push(h);
            break;
          case StatutAvisEnum.REFUSE:
            historique.push({ reference: h.reference, date: h.date, statut: StatutAvisEnum.ELABORE, type: h.type });
            historique.push({ reference: h.reference, date: h.date, statut: StatutAvisEnum.EN_ATTENTE, type: h.type });
            if (histo.dateEmission) h.date = histo.dateEmission;
            historique.push({ reference: h.reference, date: h.date, statut: StatutAvisEnum.ENVOYE, type: h.type });
            h.date = histo.historique.dateRejet;
            historique.push(h);
            break;
        }

      } else {
        h.date = histo.dateCreation;
        switch (histo.status) {
          case "EN_ATTENTE"://StatutFluxEnum.EN_ATTENTE:
            historique.push(h);
            break;
          case "ENVOYE"://StatutFluxEnum.ENVOYE:
          case "ANNULE"://StatutFluxEnum.ANNULE:
            historique.push({ reference: h.reference, date: h.date, statut: StatutAvisEnum.EN_ATTENTE, type: h.type });
            h.date = histo.dateEmission;
            historique.push(h);
            break;
          case "PUBLIE"://StatutFluxEnum.PUBLIE:
          case "REFUSE"://StatutFluxEnum.REFUSE:
            historique.push({ reference: h.reference, date: h.date, statut: StatutAvisEnum.EN_ATTENTE, type: h.type });
            h.date = histo.dateEmission;
            historique.push({ reference: h.reference, date: h.date, statut: StatutAvisEnum.ENVOYE, type: h.type });
            h.date = histo.dateReception;
            historique.push(h);
            break;
        }
      }
    });

    /*/TODO : ajouter nom avis et nom flux?
    this.histoFlux.forEach((json) => {
      const histo = JSON.parse(json);
      switch(histo.statut) {
        case StatutFluxEnum.EN_ATTENTE:
          historique.set(histo.statut, histo.dateCreation);
          break;
        case StatutFluxEnum.ENVOYE:
        case StatutFluxEnum.ANNULE:
          historique.set(StatutFluxEnum.EN_ATTENTE, histo.dateCreation);
          historique.set(histo.statut, histo.dateEmission);
          break;
        case StatutFluxEnum.PUBLIE:
        case StatutFluxEnum.REFUSE:
          historique.set(StatutFluxEnum.EN_ATTENTE, histo.dateCreation);
          historique.set(StatutFluxEnum.ENVOYE, histo.dateEmission);
          historique.set(histo.statut, histo.dateReception);
          break;
      }
    });*/
    return historique.sort((a, b) => (a.date == null) ? -1 : (b.date == null ? 1 : a.date.valueOf() - b.date.valueOf()))
  }

  private get avisService() {
    return this._avisService;
  }

  public ngOnDestroy() {
    this.subscriptions.unsubscribe();
  }
}
